export default __webpack_public_path__ + "static/media/5.566660af.jpg";